import WebLayout from './SmsOptInStatusLayout.web';
import MobileLayout from './SmsOptInStatusLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
